<template>
  <b-modal id="ModalImage" size="lg" ref="ModalImage" title="이미지 미리보기">

    <img style="width: 100%; height: auto;" :src="this.data">
    <template slot="modal-footer">
      <b-button variant="secondary" @click="hideModal">닫기</b-button>
    </template>


  </b-modal>
</template>

<script>
  export default {
    name: "ModalImage",
    props: ['data'],
    data() {
      return {

      }
    },

    methods: {
      open() {
        this.$refs['ModalImage'].show()
      },

      hideModal() {
        this.$refs['ModalImage'].hide()
      }


    },

    mounted() {
    }

  }
</script>

<style scoped>
</style>
